import React from 'react';
import { useChat } from '../contexts/ChatContext';
import MessageList from './MessageList';
import MessageInput from './MessageInput';
import ErrorDisplay from './ErrorDisplay';
import ConfigStatus from './ConfigStatus';
import './ChatInterface.css';

const ChatInterface: React.FC = () => {
  const { state } = useChat();

  return (
    <div className="chat-interface">
      <div className="chat-container">
        {/* 头部标题区域 */}
        <header className="chat-header">
          <div className="brand-section">
            <div className="brand-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7V17L12 22L22 17V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                <path d="M12 22V12" stroke="currentColor" strokeWidth="2"/>
                <path d="M2 7L12 12" stroke="currentColor" strokeWidth="2"/>
                <path d="M22 7L12 12" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </div>
            <div className="brand-text">
              <h1>Azure AI 助手</h1>
              <p>基于自有数据的智能问答</p>
            </div>
          </div>
        </header>

        {/* 聊天区域 */}
        <main className="chat-main">
          {state.error && <ErrorDisplay error={state.error} />}
          
          {/* 配置状态显示 */}
          <ConfigStatus />
          
          {state.messages.length === 0 && !state.isLoading ? (
            <div className="welcome-section">
              <div className="welcome-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M8 9H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M8 13H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h2>开始对话</h2>
              <p>向我提问任何关于您数据的问题</p>
            </div>
          ) : (
            <MessageList messages={state.messages} isLoading={state.isLoading} />
          )}
        </main>

        {/* 输入区域 */}
        <footer className="chat-footer">
          <MessageInput disabled={state.isLoading} />
        </footer>
      </div>
    </div>
  );
};

export default ChatInterface; 